import { Compatibility } from './Compatibility';
import { LogService } from '../providers';
import { compare } from 'compare-versions';

export class VersionChecker {
  private readonly compatibility: Compatibility;
  private readonly releaseVersion: string;

  constructor(releaseVersion: string, compatibilityResult: Compatibility) {
    this.compatibility = compatibilityResult;
    this.releaseVersion = releaseVersion;
  }

  public isCompatibleWithCurrent(frontendVersion: string): boolean {
    if (!this.compatibility.isCompatible) {
      LogService.info(`client not compatible`);
      return false;
    }

    if (compare(frontendVersion, this.compatibility.serverVersion, '<')) {
      LogService.info(`frontendVersion ${frontendVersion} < serverVersion ${this.compatibility.serverVersion}`);
      return false;
    }

    // customer can set a higher version in config to force update page
    if (compare(frontendVersion, this.releaseVersion, '<')) {
      LogService.info(`frontendVersion ${frontendVersion} < releaseVersion ${this.releaseVersion}`);
      return false;
    }

    return true;
  }
}
